/* eslint-disable react/require-default-props,react/no-array-index-key */
import React from 'react';
import PropTypes from 'prop-types';
import CSSModules from 'react-css-modules';
import RadioInput from '../RadioInput';
import styles from './index.styl';

const SingleSelect = ({
  name,
  list,
  onChange,
  selectClass,
  selectedValue,
  radioInputClass,
  renderContentAfterItem,
}) => (
  <div styleName="root" className={selectClass}>
    {list.map((item, index) => (
      <div
        styleName="item"
        key={`${name}-${index}`}
        className={radioInputClass}
      >
        <RadioInput
          id={`${name}-${index}`}
          label={item.label || item}
          value={item.value || item}
          name={name}
          checked={item.value === selectedValue || item === selectedValue}
          onChange={() => onChange(item.value || item)}
        />
        {renderContentAfterItem && renderContentAfterItem(item)}
      </div>
    ))}
  </div>
);

SingleSelect.propTypes = {
  name: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  list: PropTypes.arrayOf(
    PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  ).isRequired,
  selectedValue: PropTypes.string,
  selectClass: PropTypes.string,
  radioInputClass: PropTypes.string,
  onChange: PropTypes.func,
  renderContentAfterItem: PropTypes.func,
};

SingleSelect.defaultProps = {
  onChange: () => {},
};

export default CSSModules(SingleSelect, styles, { allowMultiple: true });



// WEBPACK FOOTER //
// ./src/components/common/SingleSelect/index.jsx